import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TITLES = {
  '/flow':         'Flow',
  '/ro-list':      'Jobs',
  '/timeline':     'Timeline',
  '/command':      'Command',
  '/schedule':     'Schedule',
  '/customers':    'Accounts',
  '/road-service': 'Road Service',
  '/priority':     'Priority',
};

export default function MobileHeader({ onAddClick }) {
  const navigate       = useNavigate();
  const { pathname }   = useLocation();
  const title          = TITLES[pathname] || 'REKON';

  return (
    <header style={{
      position: 'fixed',
      top: 0, left: 0, right: 0,
      height: 52,
      background: '#ffffff',
      borderBottom: '1px solid #e2e8f0',
      boxShadow: '0 1px 2px rgba(15,23,42,0.05)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 12px',
      zIndex: 200,
    }}>
      <button
        onClick={() => navigate('/home')}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 4,
          color: '#64748b', fontSize: 14, fontWeight: 600,
          padding: '6px 8px', borderRadius: 6,
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
        Home
      </button>

      <span style={{
        fontSize: 16, fontWeight: 800, color: '#0f172a', letterSpacing: 0.2,
        position: 'absolute', left: '50%', transform: 'translateX(-50%)',
      }}>
        {title}
      </span>

      <button
        onClick={onAddClick}
        style={{
          background: '#ef4444', border: 'none', cursor: 'pointer',
          width: 36, height: 36, borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#ffffff',
          boxShadow: '0 2px 8px rgba(239,68,68,0.35)',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </button>
    </header>
  );
}
